import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getPatrolService = async (site_uuid) => {
  const { data } = await supabase
    .from("patrol")
    .select()
    .eq("site_uuid", site_uuid)
    .order("id", { ascending: false });
  return await data;
};

export const getPatrolFilterTodayService = async (site_uuid, report_status) => {
  let currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 7);
  let isoString = currentDate.toISOString();
  const { data } = await supabase
    .from("patrol")
    .select()
    .eq("site_uuid", site_uuid)
    .eq("report_status", report_status)
    .gte("created_at", isoString.split("T")[0] )
    .order("id", { ascending: false });
  return await data;
};

export const getPatrolFilterAbnormalTodayService = async (site_uuid, report_status) => {
  let currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 7);
  let isoString = currentDate.toISOString();
  const { data } = await supabase
    .from("patrol")
    .select()
    .eq("site_uuid", site_uuid)
    .eq("report_status", report_status)
    // .gte("created_at", isoString.split("T")[0] )
    .order("id", { ascending: false });
  return await data;
};

export const getPatrolSearchService = async (keyword, site_uuid) => {
  const { data } = await supabase
    .from("patrol")
    .select("*")
    .eq("site_uuid", site_uuid)
    .contains("cls", [keyword]);
  //console.log(data);
  return await data;
};

export const getPatrolBySiteUuidsService = async (account_uuid, report_status) => {
  // ดึง site_uuids จาก account_site
  const { data: siteData } = await supabase
    .from("account_site")
    .select("site_uuid")
    .eq("account_uuid", account_uuid);

  if (!siteData || siteData.length === 0) {
    return [];
  }

  const site_uuids = siteData.map(site => site.site_uuid);

  // ดึงข้อมูล site names
  const { data: siteNames } = await supabase
    .from("account_site")
    .select("site_uuid, site_name")
    .in("site_uuid", site_uuids);

  // ดึงข้อมูล patrol
  const { data: patrolData } = await supabase
    .from("patrol")
    .select()
    .eq("report_status", report_status)
    .in("site_uuid", site_uuids)
    .order("id", { ascending: false });

  // Map site_names เข้ากับ patrol data
  const patrolWithSiteNames = patrolData?.map(patrol => ({
    ...patrol,
    site_name: siteNames?.find(site => site.site_uuid === patrol.site_uuid)?.site_name || ''
  })) || [];

  return patrolWithSiteNames;
};

// ฟังก์ชันใหม่สำหรับการกรอง patrol ตามช่วงวันที่
export const getPatrolByDateRangeService = async (site_uuid, startDate, endDate, report_status = null) => {
  let query = supabase
    .from("patrol")
    .select()
    .eq("site_uuid", site_uuid)
    .gte("created_at", startDate)
    .lte("created_at", endDate)
    .order("id", { ascending: false });
  
  if (report_status) {
    query = query.eq("report_status", report_status);
  }
  
  const { data } = await query;
  return await data;
};

// ฟังก์ชันสำหรับการกรอง patrol ตามปี
export const getPatrolByYearService = async (site_uuid, year, report_status = null) => {
  const startDate = `${year}-01-01`;
  const endDate = `${year}-12-31`;
  return await getPatrolByDateRangeService(site_uuid, startDate, endDate, report_status);
};

// ฟังก์ชันสำหรับการกรอง patrol ตามเดือน
export const getPatrolByMonthService = async (site_uuid, year, month, report_status = null) => {
  const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  const endDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay}`;
  return await getPatrolByDateRangeService(site_uuid, startDate, endDate, report_status);
};

// ฟังก์ชันสำหรับการกรอง checkpoint report ตามช่วงวันที่
export const getCheckpointReportByDateRangeService = async (site_uuid, startDate, endDate) => {
  const { data } = await supabase
    .from("site_patrol_report")
    .select()
    .eq("site_uuid", site_uuid)
    .gte("created_at", startDate)
    .lte("created_at", endDate)
    .order("id", { ascending: false });
  return await data;
};

// ฟังก์ชันสำหรับการกรอง checkpoint report ตามปี
export const getCheckpointReportByYearService = async (site_uuid, year) => {
  const startDate = `${year}-01-01`;
  const endDate = `${year}-12-31`;
  return await getCheckpointReportByDateRangeService(site_uuid, startDate, endDate);
};

// ฟังก์ชันสำหรับการกรอง checkpoint report ตามเดือน
export const getCheckpointReportByMonthService = async (site_uuid, year, month) => {
  const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;
  const lastDay = new Date(year, month, 0).getDate();
  const endDate = `${year}-${month.toString().padStart(2, '0')}-${lastDay}`;
  return await getCheckpointReportByDateRangeService(site_uuid, startDate, endDate);
};
